import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-ice',
  templateUrl: './magic-uses-ice.component.html',
  styleUrls: ['./magic-uses-ice.component.css']
})
export class MagicUsesIceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
